import React from 'react'
import Switch from './Switch'
import Dimmer from './Dimmer'
import RGB from './RGB'
import RGBW from './RGBW'
import WarmCold from './WarmCold'
import Thermostat from './Thermostat'
import Status from './Status'
import Curtains from './Curtains'
import {ReactComponent as IconSelect} from '../svgs/element_select.svg';

export default function Element({ui_element, params, click, boubleClick, clickPlus, clickMinus, longTouch, touchend, ui_language}){
    
    let ui_element_id = ui_element.ui_item_id
    let ui_element_type = ui_element.ui_item_type
    let ui_element_icon = ui_element.ui_item_icon_id
    let ui_element_name = 'default name'
    if (ui_element.display_name !== "") ui_element_name = ui_element.display_name
    let ui_element_params = ui_element.params
    let ui_element_add_data = ui_element.add_data
    let units = ''
    let ui_element_div = <div className="elem_div"> <p></p>DIV NOT FOUND </div>
    const classes = []
    let param_value
    
    switch (ui_element_type) {
        case 'switch':
            ui_element_params.map( param => {
                if(param.param_sub_id === 'state') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value = state.param_value
                        }
                    }
                    )
                }
            })
            if (param_value == 'true') classes.push('elem_active')
            ui_element_div = <div className="elem_div" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>
                <Switch ui_element_id={ui_element_id} param_value={param_value} ui_element_svg_id={ui_element_icon}/>
            </div>;
            break;
        case 'dimmer':
            ui_element_params.map( param => {
                if(param.param_sub_id === 'bright') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value = state.param_value
                        }
                    }
                    )
                }
            })
            if (param_value > 0) classes.push('elem_active')
            ui_element_div = <div className="elem_div" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}> 
                <Dimmer ui_element_id={ui_element_id} param_value={param_value} ui_element_svg_id={ui_element_icon}/>
            </div>;
            break;

        case 'rgb':
            param_value = {hue: NaN, bright: NaN, saturation: NaN}
            ui_element_params.map( param => {
                if(param.param_sub_id === 'bright') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.bright = state.param_value
                        }
                    }
                    )
                }
                if(param.param_sub_id === 'hue') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.hue = state.param_value
                        }
                    }
                    )
                }
                if(param.param_sub_id === 'saturation') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.saturation = state.param_value
                        }
                    }
                    )
                }
            })
            if (param_value.bright > 0) classes.push('elem_active')
            ui_element_div = <div className="elem_div" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>
                <RGB ui_element_id={ui_element_id} param_value={param_value} ui_element_svg_id={ui_element_icon}/>
            </div>;
            break;

        case 'rgbw':

            param_value = {hue: NaN, bright: NaN, saturation: NaN}
            ui_element_params.map( param => {
                if(param.param_sub_id === 'bright') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.bright = state.param_value
                        }
                    }
                    )
                }
                if(param.param_sub_id === 'hue') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.hue = state.param_value
                        }
                    }
                    )
                }
                if(param.param_sub_id === 'saturation') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.saturation = state.param_value
                        }
                    }
                    )
                }
            })

            if (param_value.bright > 0) classes.push('elem_active')
            ui_element_div = <div className="elem_div" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>
                
                <RGBW ui_element_id={ui_element_id} param_value={param_value} ui_element_svg_id={ui_element_icon}/>
            </div>;
            break;

        case 'warm_cold':
            param_value = {hue: NaN, bright: NaN}
            ui_element_params.map( param => {
                if(param.param_sub_id === 'bright') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.bright = state.param_value
                        }
                    }
                    )
                }
                if(param.param_sub_id === 'hue') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.hue = state.param_value
                        }
                    }
                    )
                }
            })
            if (param_value.bright > 0) classes.push('elem_active')
            
            ui_element_div = <div className="elem_div" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>  
                <WarmCold ui_element_id={ui_element_id} param_value={param_value} ui_element_svg_id={ui_element_icon}/>
            </div>;
            break;

        case 'thermostat':
            param_value = {curr_temp: NaN, comf_temp: NaN, mode: NaN, units: NaN}
            if (JSON.parse(ui_element_add_data)) units = JSON.parse(ui_element_add_data).units
            ui_element_params.map( param => {
                if(param.param_sub_id === 'curr_temp') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.curr_temp = state.param_value
                        }
                    }
                    )
                }
                if(param.param_sub_id === 'comf_temp') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.comf_temp = state.param_value
                        }
                    }
                    )
                }
                if(param.param_sub_id === 'mode') {
                    params.map(state =>{
                        if (param.param_id === parseInt(state.param_id)){
                            param_value.mode = state.param_value
                        }
                    }
                    )
                }
            })
            if (param_value.mode > 1) classes.push('elem_active')
            ui_element_div = <div className="elem_div" onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>
                <Thermostat ui_element_id={ui_element_id} param_value={param_value} units={units} ui_element_svg_id={ui_element_icon} clickPlus={clickPlus} clickMinus={clickMinus} ui_language={ui_language}/>
            </div>;
            break;

        case 'status':
        param_value = ''
        ui_element_params.map( param => {
            if(param.param_sub_id === 'text') {
                params.map(state =>{
                    if (param.param_id === parseInt(state.param_id)){
                        param_value = state.param_value
                        //console.log('elem_param_value', param_value)
                    }
                }
                )
            }
        })
        let status_type = 'text'
        let add = ''
        if (JSON.parse(ui_element_add_data)) status_type = JSON.parse(ui_element_add_data).type
        switch (status_type) {
            case 'text':
                if (param_value == null) {
                    param_value = '';
                }
                else {
                    param_value = param_value.toString().replace(/"/g,'')
                }
                if (JSON.parse(ui_element_add_data)) add = JSON.parse(ui_element_add_data).units
                break;
            case 'icon_activity':
            case 'icon_status_color':
                if (JSON.parse(ui_element_add_data)) add = JSON.parse(ui_element_add_data).icon_id
                break;
        }
        ui_element_div = <div className="elem_div" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>
            <Status ui_element_id={ui_element_id} param_value={param_value} add={add} status_type={status_type}/>
        </div>;
        if (param_value != '') classes.push('elem_active')
        break;

        case 'curtains':
        param_value = {curr_pos: NaN, target_pos: NaN}
        ui_element_params.map( param => {
            if(param.param_sub_id === 'curr_pos') {
                params.map(state =>{
                    if (param.param_id === parseInt(state.param_id)){
                        if (state.param_value) param_value.curr_pos = parseInt(state.param_value)
                        else param_value.curr_pos = 0
                    }
                }
                )
            }
            if(param.param_sub_id === 'target_pos') {
                params.map(state =>{
                    if (param.param_id === parseInt(state.param_id)){
                        if (state.param_value) param_value.target_pos = parseInt(state.param_value)
                        else param_value.target_pos = 0
                    }
                }
                )
            }
        })
        
        if (param_value.curr_pos > 0) classes.push('elem_active')
        ui_element_div = <div className="elem_div" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>
            
            <Curtains ui_element_id={ui_element_id} param_value={param_value} ui_element_svg_id={ui_element_icon}/>
        </div>;
        break;
    }
    return(
            <div className={'element ' + classes.join(' ')}>
                {ui_element_div}
                <div className="element-name" onClick={()=> click(ui_element_id)} onTouchStartCapture={()=>longTouch(ui_element_id)} onTouchEndCapture={()=>touchend()} onContextMenu={()=>boubleClick(ui_element_id)}>{ui_element_name}</div>
                <div className="element_select_button" onClick={()=> boubleClick(ui_element_id)}><IconSelect/></div>
            </div>
    )
}